import { render, staticRenderFns } from "./nav-item.vue?vue&type=template&id=896648c8&scoped=true&"
import script from "./nav-item.vue?vue&type=script&lang=js&"
export * from "./nav-item.vue?vue&type=script&lang=js&"
import style0 from "./nav-item.vue?vue&type=style&index=0&id=896648c8&lang=sass&scoped=true&"
import style1 from "./nav-item.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896648c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('896648c8')) {
      api.createRecord('896648c8', component.options)
    } else {
      api.reload('896648c8', component.options)
    }
    module.hot.accept("./nav-item.vue?vue&type=template&id=896648c8&scoped=true&", function () {
      api.rerender('896648c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/navegacao-v2/components/nav-item.vue"
export default component.exports